import { Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { LocaleService } from 'src/app/services/locale.service';
import { Badge } from 'src/app/gamification/services/models/badges.model';
import anime, { AnimeInstance } from 'animejs';

@Component({
  selector: 'app-gamification-badge',
  templateUrl: './gamification-badge.component.html',
  styleUrls: ['./gamification-badge.component.scss'],
})
export class GamificationBadgeComponent implements OnInit {
  private static readonly COUNT_ANIM_DURATION = 1500;

  private readonly localeService = inject(LocaleService);

  @Input() badge: Badge;
  @Input() set isFinishedAnimation(value: boolean) {
    if (value && this.animation && !this.animation.began) {
      this.animation.play();
    }
  }

  readonly percentage = computed(() => Math.floor((100 * this.badge.progress) / this.badge.goal));
  readonly unitTypeLabel = computed(() => this.localeService.instant(`user.badges.unitTypes.${this.badge.unitType}`));

  readonly activation = signal(0);

  animation: AnimeInstance;
  progressObject = {
    percentage: 0,
  }

  ngOnInit(): void {
    if (this.percentage() === 100 && this.badge.goal === 1) {
      this.activation.set(100);
    } else {
      this.animation = anime({
        targets: this.progressObject,
        percentage: this.percentage,
        easing: 'easeOutQuad',
        duration: GamificationBadgeComponent.COUNT_ANIM_DURATION,
        autoplay: false,
      });
    }
  }
}
